import React from 'react';
import ChannelSearchCircleListView from 'components/lane/ChannelSearchCircleListView';
import type { Channel } from 'application-types';

type Company = {
  id: string;
  name: string;
  thumbnailUrl: string | null;
  inviteOnly: boolean;
};

type Edge = {
  cursor: string;
  node: Company;
};

type ChannelSearchCircleListWrapperProps = {
  company: Edge;
  className?: string;
  style?: React.CSSProperties;
  onClick: (channel: Channel) => void;
  hideDescription?: boolean;
  isSelected?: boolean;
};

export function ChannelSearchCircleListWrapper({
  company,
  className,
  style,
  onClick,
  hideDescription = false,
  isSelected,
}: ChannelSearchCircleListWrapperProps) {
  const channel = convertCompanyEdgeToChannelType(company);

  return (
    <ChannelSearchCircleListView
      className={className}
      style={style}
      channel={channel}
      onClick={onClick}
      hideDescription={hideDescription}
      isSelected={isSelected}
    />
  );
}

export function convertCompanyEdgeToChannelType(company: Edge): Channel {
  return {
    _id: company.node.id,
    profile: {
      name: company.node.name,
      logo: company.node.thumbnailUrl,
    },
    inviteOnly: company.node.inviteOnly,
  } as Channel;
}
